import type { CSSProperties } from 'react';

/** Einzelner Schimmer-Block. */
export function Skeleton({
  width,
  height = '1rem',
  style,
}: {
  width?: string | number;
  height?: string | number;
  style?: CSSProperties;
}) {
  return (
    <span
      className="au-skeleton"
      style={{ width: width ?? '100%', height, ...style }}
      aria-hidden
    />
  );
}

/** Mehrere Textzeilen (letzte kürzer) — für Detail-/Formularflächen. */
export function SkeletonText({ lines = 3 }: { lines?: number }) {
  return (
    <div className="au-skeleton-stack" role="status" aria-label="Lädt …">
      {Array.from({ length: lines }, (_, index) => (
        <Skeleton key={index} width={index === lines - 1 ? '60%' : '100%'} />
      ))}
    </div>
  );
}

/** Tabellen-Platzhalter: Kopfzeile + n Zeilen. */
export function SkeletonTable({ rows = 5 }: { rows?: number }) {
  return (
    <div className="au-skeleton-stack" role="status" aria-label="Lädt …">
      <Skeleton height="0.8rem" width="40%" />
      {Array.from({ length: rows }, (_, index) => (
        <Skeleton key={index} height="2.2rem" />
      ))}
    </div>
  );
}
